import Vue from "vue";
import Router from "vue-router";
import routes from "@/config/routes";
import store from "./store";
import routerConfig from "@/config/router";
import axios from 'axios';

Vue.use(Router);

const router = new Router({
    ...routerConfig,
    routes: routes
});

let pageLoader = null;
let pageLoaderTimeout = null;

const later = () => {
    if (!pageLoader) {

    }
    pageLoaderTimeout = null;
};

const showPageLoader = () => {
    clearTimeout(pageLoaderTimeout);
    pageLoaderTimeout = setTimeout(later, 200);
};

const hidePageLoader = () => {
    clearTimeout(pageLoaderTimeout);
    pageLoaderTimeout = null;
    if (pageLoader) {
        pageLoader.hide();
        pageLoader = null;
    }
};

router.beforeEach((to, from, next) => {
    if (to.name !== 'auth.login' && to.name !== 'auth.forgot' && !store.state.authStore.logged) {
        next('/auth/login')
    } else if ((to.name === 'auth.login' || to.name === 'auth.forgot') && store.state.authStore.logged) {
        next('/afiliado/ficha')
    } else if (store.state.authStore.logged) {
        if (to.name !== 'notFound' && to.name !== '' && to.name !== null) {
            let routesKeys = to.name.split('.')
            if (routesKeys[0] !== 'auth' && store.state.authStore.user.permisos_modulos[routesKeys[0]][routesKeys[1]]) {
                store.state.crudStore.namePath = routesKeys[0] + '_' + routesKeys[1]
                next();
            } else if (routesKeys[0] !== 'auth') {
                next('/afiliado/ficha');
            } else {
                next();
            }
        } else {
            next('/afiliado/ficha');
        }
    } else {
        next()
    }
});

router.beforeResolve((to, from, next) => {
    next();
});

export default router;